import React, { useEffect } from "react"
import PropTypes from "prop-types"
import InputRatingStars from "@src/components/input-rating-stars"
import styled from "styled-components"
import { useFormContext } from "react-hook-form"

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .error-message {
    color: red;
    font-size: 16px;
    font-weight: 700;
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    .icon-close {
      color: red;
    }
    .icon-check {
      color: green;
    }
    span {
      display: flex;
      color: black;
      font-weight: 400;

      div {
        width: 20px;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 4px;
      }
    }
  }
`

const InputLabel = styled.div`
  display: block;
  font-size: 18px;
  font-weight: 700;
  line-height: 32px;
  color: #667085;
`

const InputStars = ({ label, name, value, max, validate }) => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext()

  useEffect(() => {
    validate ? register(name, { validate: validate }) : register(name)
    if (value !== getValues(name)) {
      setValue(name, value)
    }
  }, [getValues, name, register, setValue, validate, value])

  return (
    <InputWrapper>
      <InputLabel>{label}</InputLabel>
      <InputRatingStars
        name={name}
        value={value}
        label={label}
        max={max}
        className="field-input"
        onChange={event => {
          setValue(name, event)
        }}
      />
      {errors[name] && (
        <span
          className="error-message"
          dangerouslySetInnerHTML={{ __html: errors[name].message }}
        ></span>
      )}
    </InputWrapper>
  )
}
InputStars.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.number,
  max: PropTypes.number,
  validate: PropTypes.func,
}
export default InputStars
